<form [formGroup]="form" *ngIf="form">
  <div class="d-flex flex-row">
    <input id="person-add" class="person-add-input flex-grow-1" type="text" formControlName="search"
      autocomplete="off" placeholder="{{'ChangePlayer.SearchPlayerPlaceholder' | translate}}">
    <button class="btn btn-light-blue btn-sm ml-2" (click)="addNewPerson()" [disabled]="!canAddNewPlayer"
      translate>CourtBookingSave.AddNewPlayerButton</button>
  </div>
</form>
<div class="mx-5 mt-3 mb-2" *ngIf="showAddPlayerExists"
  translate>
  CourtBookingSave.AddNewPlayerPLayersFound
</div>
<ul *ngIf="showPlayerList" class="person-search-list" role="menu" aria-labelledby="person-search">
  <li *ngFor="let player of players" (click)="onSelectPerson(player)">
    <app-court-booking-player-info [showRemoveButton]="false" [person]="player"></app-court-booking-player-info>
  </li>
</ul>
